import { Component } from '@angular/core';
import { ApplicationStateService } from '../../../../../services/application-state.service';
import { OfflineModeService } from '../../../../../services/offline-mode.service';
import { ModalComponent } from '../../../../../models/modal-component';

@Component({
    selector: 'app-offline-version-modal',
    templateUrl: './offline-version-modal.component.html',
    styleUrls: ['./offline-version-modal.component.scss']
})

export class OfflineVersionModalComponent extends ModalComponent {
    static MODAL_ID = 'offlineVersionModal';

    constructor(public applicationStateService: ApplicationStateService,
                public offlineModeService: OfflineModeService) {
        super();
    }

    getId(): string {
        return OfflineVersionModalComponent.MODAL_ID;
    }
}